import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2;

import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import { hasPricingAndPurchasingSucceededSelector } from 'pricing-pages-ui/selectors/LoadingStateSelectors';
import SkeletonLoadWrapper from '../../common/loading/SkeletonLoadWrapper';
import CardLayout from './CardLayout';
import { CrmSuitePrice } from '../../merch-card/price-display/CrmSuitePrice';
import { MONTHLY } from 'self-service-api/constants/Terms';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { STARTER_SUITE_CARD } from '../../../constants/tracking/Locations';
import { StarterCrmSuiteBOTranslationKeys } from '../../../constants/BusinessObjectivesTranslationKeys';
import I18n from 'I18n';
const StyledContainer = styled.span.withConfig({
  displayName: "StarterCrmSuiteCard__StyledContainer",
  componentId: "sc-1lt2phs-0"
})(["display:flex;flex-direction:column;justify-content:space-between;height:100%;", " div:first-child{margin-top:0 !important;}div:nth-child(2){justify-content:center;}"], breakpoint.tablet(_t || (_t = _`
    align-items: center;
  `)));
const StyledLoader = styled(SkeletonLoadWrapper).withConfig({
  displayName: "StarterCrmSuiteCard__StyledLoader",
  componentId: "sc-1lt2phs-1"
})(["", ""], breakpoint.tablet(_t2 || (_t2 = _`
    align-items: center;
  `)));

const StarterCrmSuiteCard = ({
  screen,
  tab
}) => {
  const isAppAuth = useSelector(isAppAuthSelector);
  const history = useHistory();
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);

  const handleLegalLinkClick = () => {
    const url = isAppAuth ? '/suite' : '/suite/starter';
    getUsageTracker().track('internalLinkClick', {
      name: 'explore-link',
      url,
      trackingSource: STARTER_SUITE_CARD,
      screen,
      tab
    });
    window.scrollTo(0, 0);
    history.push(url);
  };

  return /*#__PURE__*/_jsx(CardLayout, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "splash-page.bundles.STARTER.title"
    }),
    descriptionSubtext: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "splash-page.bundles.STARTER.description"
    }),
    ctasComponent: /*#__PURE__*/_jsxs(StyledContainer, {
      children: [/*#__PURE__*/_jsx(StyledLoader, {
        isLoading: !hasPricingAndPurchasingSucceeded,
        heights: [25, 35],
        widths: [50, 90],
        className: "flex-column align-left",
        Content: CrmSuitePrice,
        contentProps: {
          productLevel: STARTER,
          termOverride: MONTHLY,
          wrapperStyle: {
            textAlign: 'left'
          }
        }
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        onClick: handleLegalLinkClick,
        className: "m-top-4 p-x-8",
        "aria-label": I18n.text('splash-page.exploreProduct', {
          product: I18n.text(`splash-page.bundles.STARTER.title`)
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "splash-page.explore"
        })
      })]
    }),
    bizObjectives: StarterCrmSuiteBOTranslationKeys
  });
};

export default StarterCrmSuiteCard;